import React from 'react';
import { GAME_LOGO } from '../../../utils/assets';

export default function Landing({ onStart }) {
  return (
    <div className="orb-screen orb-landing">
      <div className="orb-spacer" />
      <img className="orb-logo orb-landing-logo" src={GAME_LOGO} alt="Ask The Orb" />

      {/* Short gap above, roomier below: the CTA sits high, near the logo. */}
      <div className="orb-spacer is-short" />

      <button type="button" className="orb-btn" onClick={onStart}>
        ✦ Ask The Orb ✦
      </button>

      {/* Sits right under the CTA, not pinned to the bottom of the screen. */}
      <div className="orb-footnote">Curious answers · Magical insights</div>

      <div className="orb-spacer" />
    </div>
  );
}
